// Textos transcritos literalmente del formato impreso "LIBRANZA" de Inversiones
// Osviel S.A.S. Son textos jurídicos: no reescribir sin autorización del área
// responsable del formato.
//
// Las negritas del impreso van marcadas con ** ** y los subrayados con __ __
// dentro del mismo texto, en lugar de partir cada párrafo en fragmentos: así
// cada constante se coteja de un vistazo contra la hoja impresa. El documento
// las separa al renderizar.

export const OPERADORA = {
    razonSocial: 'INVERSIONES OSVIEL S.A.S.',
    lema: 'SU OPERADORA DE LIBRANZA',
    // El membrete de la libranza trae el régimen y un teléfono fijo que no están
    // en el pie de los demás formatos; se deja como en el impreso.
    nit: 'NIT. 900.344.946-3 RÉGIMEN COMÚN',
    direccion: 'Calle 13 No. 8-94 Barrio Centro 2do. Piso',
    telefonos: 'Teléfono: (605) 726 0049 - Cel. 301 662 1260',
    ciudad: 'Maicao, La Guajira - Colombia',
};

export const AUTORIZACION_GIRO =
    'Autorizo expresa e irrevocablemente a la **ENTIDAD PAGADORA**, para que las sumas retenidas o ' +
    'descontadas mensualmente en los términos aquí establecidos, sean giradas o depositadas ' +
    'mensualmente a la cuenta bancaria que para tal fin **LA ENTIDAD OPERADORA** designe, dentro del ' +
    'término fijado para tal efecto, cancelando de esta forma el crédito que me fue concedido. Si la ' +
    '**ENTIDAD PAGADORA** en la que me encuentro vinculado(a) no descuenta y no paga a **LA ENTIDAD ' +
    'OPERADORA** el valor de la(s) cuota(s) mensual(es) del(los) respectivo(s) crédito(s), no quedo ' +
    'exonerado(a) de la responsabilidad de pagar la(s) cuota(s) mensual(es) y eventuales intereses de mora.';

export const MODIFICACION_CONDICIONES =
    'Autorizo para que en el evento que se modifique el(los) plazo(s), cuota(s) o interés(es) del(los) ' +
    'crédito(s), estos se realicen y se comuniquen a la **ENTIDAD PAGADORA.**';

export const TERMINACION_CONTRATO =
    'En caso de que se llegare a terminar o finalizar mi contrato por cualquier causa, autorizo a la ' +
    '**ENTIDAD PAGADORA** a retener y descontar de la liquidación de mis prestaciones sociales legales ' +
    'y extralegales e indemnizaciones a que tenga derecho o cualquier otra acreencia laboral o ' +
    'comercial, el(los) saldo(s) del(los) crédito(s) mencionado(s) y los intereses a que hubiera lugar.';

export const TERMINACION_ACUERDO =
    'Declaro que conozco y acepto que en caso que ocurra la terminación o finalización del **ACUERDO ' +
    'OPERATIVO DE LIBRANZA**, entre la **ENTIDAD OPERADORA** y la **ENTIDAD PAGADORA**, se cobrará la ' +
    'tasa de interés comercial consignada en el pagaré y por lo tanto no continuaran vigentes las ' +
    'condiciones comerciales o preferenciales estipuladas en la Libranza.';

export const REGLAMENTOS =
    'Finalmente declaro que conozco los reglamentos de los créditos otorgados por libranza y su ' +
    'aceptación, para lo cual me acojo a ellos incluso asumiendo que la **ENTIDAD PAGADORA** solo es un ' +
    'canal de pago y que la administración de los productos y servicios se realizarán directamente por ' +
    'los canales establecidos por la **ENTIDAD OPERADORA**.';

export const CONSTANCIA_CONSENTIMIENTO =
    'Dejo expresa constancia que al momento de realizar el presente crédito estoy en uso de mis ' +
    'facultades mentales y no tengo ningún vicio de consentimiento, en consecuencia manifiesto bajo la ' +
    'gravedad de juramento que acepto en forma libre y espontánea las condiciones del presente crédito, ' +
    'así como la tasa de interés del crédito otorgado.';

export const TITULO_ESPACIO_PAGADORA = 'ESPACIO EXCLUSIVO PARA LA ENTIDAD PAGADORA';

export const COMPROMISO_PAGADORA =
    'De acuerdo con la Ley 1527 del 27 de Abril de 2012 y la Ley 1902 del 22 de Junio de 2018 y demás ' +
    'normas reglamentarias, la **ENTIDAD PAGADORA** se compromete a efectuar los descuentos autorizados ' +
    'en la presente libranza por el asalariado, contratado por prestación de servicios, asociado(a) a ' +
    'una cooperativa o pre cooperativa, fondo de empleados o pensionado, los cuales no podrán exceder ' +
    'del 50% del pago mensual que devengue el deudor, cliente o beneficiario del crédito, por concepto ' +
    'de salario, pagos u honorarios, aportes o ahorros, mesada o asignación pensional o de cualquier ' +
    'otra suma de dinero. la **ENTIDAD PAGADORA** procederá a girar a nombre de la **ENTIDAD OPERADORA** ' +
    'los valores retenidos a los asalariados, contratados por prestación de servicios, asociados a una ' +
    'cooperativa o pre cooperativa, fondo de empleados o pensionado.';

// Encabezado del párrafo de autorización. Se arma en el documento porque
// intercala los datos del deudor, pero los tramos fijos viven aquí.
export const AUTORIZACION = {
    mayorEdad: ', Mayor de edad, domiciliado en la ciudad de ',
    identificado: ', identificado(a) con cedula de ciudadanía N° ',
    autorizo: ', autorizo expresa e irrevocablemente a la empresa ',
    marcoLegal:
        ', en adelante la **ENTIDAD PAGADORA**, de acuerdo a la Ley 1527 del 27 de Abril de 2012, la ' +
        'Ley 1902 del 22 de Junio de 2018 __“por medio de la cual se establece un marco general para la ' +
        'libranza o descuento directo”__ y demás normas reglamentarias; para que de mi salario, pagos u ' +
        'honorarios o pensión u otra suma de dinero que devengue como ',
    retencion: ', sean retenidas o descontadas mensualmente la suma de $',
    durante: ' m/cte. durante ',
    cierre:
        ' cuotas, del crédito del que soy deudor ante **INVERSIONES OSVIEL S.A.S.**, en adelante ' +
        '**ENTIDAD OPERADORA DE LIBRANZA**, aún en el evento de encontrarme disfrutando de vacaciones, ' +
        'licencias e incapacidades.',
};
